import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import Fade from 'react-reveal/Fade'
import FormAction from "./formAction";
function Transcripts(props) {
  const [state, setState] = useState({
    formData: {
      percent_completed: 80,
      submit_transcripts: null,
    },
    submit_transcriptsValid: "",
    isFormDataValid: false,
  });

  const numberInputs = {};
  const stepFields = ["submit_transcripts"];

  const { savedSteps, bayanProgress, selectedProgramLabel } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      bayanProgress: state.applicationReducer.bayanProgress,
      selectedProgramId: state.applicationReducer.selectedProgramId,
      selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    }),
    shallowEqual
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!!savedSteps.transcripts) {
      populateForm();
    }
  }, []);

  useEffect(() => {
    validateForm();
  }, [state]);

  function populateForm() {
    const transcriptsData = savedSteps.transcripts;
    if (!!savedSteps.transcripts && Object.keys(transcriptsData).length > 0) {
      updateForm("submit_transcripts", transcriptsData.submit_transcripts);
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData;
    temp[field] = value;
    setState((prevState) => ({ ...prevState, formData: temp }));
    _validate(field);
  };
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch (field) {
      case "submit_transcripts":
        regex = /^.{1,}/;
        valid = regex.test(value);
        break;
    }
    setState((prevState) => ({ ...prevState, [field + "Valid"]: valid }));
  };

  const validateForm = () => {
    let formData = state;
    let form = !!formData.submit_transcriptsValid;
    if (state.isFormDataValid != form) {
      setState((prevState) => ({ ...prevState, isFormDataValid: form }));
    }
  };

  return (
    <>
      <div className="app-form-container demographic residency">
        <div className="main-heading bayan-main-heading">
          {selectedProgramLabel}
        </div>
        <div className="sub-heading app-info">Transcripts*</div>
        <div className="form-content">
          <div className="input-group">
            <div className="field-label">
              I confirm that I have ordered ALL of my official transcripts from
              any college or university that I have attended or am currently
              attending to be sent directly to CTS by mail or email.
              <br />
              <br />
              If they are being sent electronically, have your previous
              institution send them to: admissions@ctschicago.edu
              <br />
              <br />
              If they are being mailed:
              <br />
              Admissions, Chicago Theological Seminary 1407 E. 60th St.,
              Chicago, IL 60637
              <br />
              <br />
              Submit all transcripts, including institutions where you have not
              earned a degree or have transferred credits.
            </div>
            <div className="inline-f-b mt-20">
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.submit_transcripts == 1 ? "selected" : ""
                    }`}
                    onClick={() => {
                      updateForm("submit_transcripts", 1);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("submit_transcripts", 1);
                    }}
                  >
                    Yes
                  </div>
                </div>
              </div>
              <div className="inline-radio">
                <div className={`radio-options`}>
                  <div
                    className={`radio-button ${
                      state.formData.submit_transcripts == 0 ? "selected" : ""
                    }`}
                    onClick={() => {
                      updateForm("submit_transcripts", 0);
                    }}
                  ></div>
                  <div
                    className={`radio-label`}
                    onClick={() => {
                      updateForm("submit_transcripts", 0);
                    }}
                  >
                    No
                  </div>
                </div>
              </div>
            </div>
            {state.submit_transcriptsValid === false && (
              <div className="field-error">Must select an option.</div>
            )}
          </div>
        </div>
      </div>
      <FormAction
        isFormDataValid={state.isFormDataValid}
        formData={state.formData}
        formStep={"transcripts"}
        backStep={"toeflScore"}
        nextStep={"references"}
      />
    </>
  );
}

// const mapStateToProps = state => ({
//   savedSteps: state.application.savedSteps,
//   reqForm: state.user.data,
// })

export default Transcripts;
